var f = Object.defineProperty, x = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var i = (r, t, o) => t in r ? f(r, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[t] = o, n = (r, t) => {
  for (var o in t || (t = {}))
    y.call(t, o) && i(r, o, t[o]);
  if (p)
    for (var o of p(t))
      h.call(t, o) && i(r, o, t[o]);
  return r;
}, m = (r, t) => x(r, c(t));
import { jsx as l } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { a as u } from "./factory-ueRxoNOV.js";
function C(r) {
  const t = a(r);
  return t.withProps = (o) => {
    const e = a((d, s) => /* @__PURE__ */ l(t, m(n(n({}, o), d), { ref: s })));
    return e.extend = t.extend, e.displayName = `WithProps(${t.displayName})`, e;
  }, t.extend = u, t;
}
export {
  C as p
};
